import React, { useMemo, useState } from "react";
import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import AcceptPaidTaskButton from "../PaidTask/PaidTaskView/AcceptPaidTaskButton";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { translate } from "../../services/Translations/translatorService";
import { convertFromFloat } from "../../services/formServiceFunctions";
import InputAdornment from "@mui/material/InputAdornment";
import { PaidTask } from "../../types/PaidTask";
import {
  getFullProductLabel,
  getProductData,
  getProductNameBy,
} from "../../services/Product/ProductService/productService";
import dayjs from "dayjs";

export default function CasePaidTaskAccept({ paidTask }: { paidTask: PaidTask }) {
  const [open, setOpen] = useState<boolean>(false);
  const fullProductLabel = useMemo<string>(() => {
    const productClassName = getProductNameBy("lbProductClass", paidTask.backofficeCase.lbProductClass);
    return getFullProductLabel({
      productClassName,
      productCategory: getProductData(productClassName, "productCategory"),
    });
  }, [paidTask.backofficeCase.lbProductClass]);

  return (
    <>
      <Button onClick={() => setOpen(true)} color={"primary"}>
        Details und Annahme
      </Button>
      <LegalbirdIoModal
        handleClose={() => setOpen(false)}
        open={open}
        title={"Aufgabe"}
        hasActions={true}
        hideCancelButton={false}
        submitButton={<AcceptPaidTaskButton paidTask={paidTask} />}
        disableBackdropClick={false}
      >
        <Grid container>
          <Grid size={12}>
            <Typography variant="h5" sx={{ textAlign: "center" }}>
              {fullProductLabel}
            </Typography>
          </Grid>
          <Grid size={12}>
            <TextField disabled={true} label={translate("paidTask.subject")} value={paidTask.subject} />
          </Grid>
          <Grid size={12}>
            <TextField
              multiline
              disabled={true}
              label={translate("paidTask.description")}
              value={paidTask.description}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              multiline
              disabled={true}
              label={translate("paidTask.definitionOfDone")}
              value={paidTask.definitionOfDone}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              disabled={true}
              label={translate("paidTask.fee")}
              value={convertFromFloat(paidTask.fee)}
              slotProps={{
                input: {
                  endAdornment: <InputAdornment position="start">€</InputAdornment>,
                }
              }}
            />
          </Grid>
          <Grid sx={{ padding: "0 0.5rem" }} size={5}>
            <TextField
              disabled={true}
              label={translate("paidTask.assignmentDeadline")}
              value={dayjs(paidTask.assignmentDeadline).format("DD.MM.YYYY")}
            />
          </Grid>
          <Grid size={5}>
            <TextField
              disabled={true}
              label={translate("paidTask.doneDeadline")}
              value={dayjs(paidTask.doneDeadline).format("DD.MM.YYYY")}
            />
          </Grid>
        </Grid>
      </LegalbirdIoModal>
    </>
  );
}
